import { makeStyles } from "@material-ui/styles";
import { colors } from '../../colors';

export const useStyles = makeStyles({
  container: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: (themeColor) => themeColor.primary,
    "& .MuiBottomNavigationAction-root": {
      color: colors.disabled,
    },
    "& .Mui-selected": {
      color: "#fff",
    },
    "& .MuiSvgIcon-root": {
      height: "1.6rem",
      width: "1.6rem",
    },
    "& .MuiBottomNavigationAction-label": {
      fontSize: "1rem",
    },
  },
});